import React, { useState, useEffect } from "react";
import Head from "next/head";
import { makeStyles } from "@mui/styles";
import Layout from "../../components/Layout/Layout";
import { Box, Typography, Link } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  root: {
    background: "#19132A",
    width: "100%",
    maxWidth: "576px",
    height: "121px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    color: "white",
    position: "fixed",
    top: "100px",
    left: "50%",
    transform:"translateX(-50%)",
    borderRadius: "24px",
    padding: "0 30px",
    zIndex: 1100,
    '@media(max-width:767px)':{
      width:"90%",
    },
  },
  alertMessage: {
    display: "flex",
    alignItems: "center",
    position: "relative",
    width: "100%",
  },
  content: {
    marginLeft: "10px",
    fontSize: "18px",
  },
}));

export default function Alert({ visible = false, message }) {
  const classes = useStyles();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(visible);
  }, [visible]);

  return (
    <>
      {isVisible && (
        <Box className={classes.root}>
          <Box className={classes.alertMessage}>
            <Box
              component="img"
              src="/images/alert/success-icon.svg"
              width="20px"
            />
            <Typography variant="span" className={classes.content}>
              {message}
            </Typography>
          </Box>
          <Link
            href="#"
            onClick={() => {
              console.log("close");
              setIsVisible(false);
            }}
          >
            <Box
              component="img"
              src="/images/alert/close-icon.svg"
              width="20" style={{cursor:"pointer"}} 
            />
          </Link>
        </Box>
      )}
    </>
  );
}
